module.exports = __webpack_public_path__ + "static/media/wb_180.2b1b9a1b.svg";